import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGreenPower: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="green-power, green-energy"><path d="M13.5 7L9 12.5H11.5V16L16 10.5H13.5V7Z" fill="currentColor"/><path d="M3.74869 20.2422L6.16294 17.828M6.16294 17.828C-0.372693 9.93872 6.83979 0.665628 19.7191 4.27183C23.3252 17.1512 14.0521 24.3636 6.16294 17.828Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGreenPower;
